export const SMART_TAX_INDEX = 'smart-tax';
export const SMART_TAX_INDEX_URL = `/${SMART_TAX_INDEX}/*`;

export const SMART_TAX_PAGE_TITLE = 'Smart Tax';

export const SMART_TAX_PATHS = {
  import: '/import',
  processing: '/processing',
  pendingApprovalReview: 'review/:uuid',
};
